// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSharedWebAddressModel {
    static getAttributeTypeMap() {
        return PayorSharedWebAddressModel.attributeTypeMap;
    }
}
PayorSharedWebAddressModel.discriminator = undefined;
PayorSharedWebAddressModel.additionalProperties = false;
PayorSharedWebAddressModel.attributeTypeMap = [
    {
        "name": "webAddressId",
        "baseName": "webAddressId",
        "type": "number"
    },
    {
        "name": "webAddressType",
        "baseName": "webAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
];
//# sourceMappingURL=payorSharedWebAddressModel.js.map